import PropTypes from 'prop-types';
import {Component} from 'react';
import {Dropdown} from 'semantic-ui-react';
import './MonthYear.scss';


export default class MonthYear extends Component {


  static propTypes = {
    month: PropTypes.string,
    year: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };


  render() {
    const {month, year, onChange} = this.props;
    let currentYear = new Date().getFullYear();
    const years = Array(20).fill(0).map((e, i) => {
      let y = (currentYear - i).toString();
      return {key: y, value: y, text: y};
    });
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'].map((e) => ({key: e, value: e, text: e}));

    return (
      <div className="month-year">
        <Dropdown
          className="month-select"
          placeholder="Select month"
          search
          selection
          clearable="true"
          options={months}
          value={month}
          onChange={(e, data) => onChange({month: data.value})}
        />
        <Dropdown
          className="year-select"
          placeholder="Select year"
          search
          selection
          clearable="true"
          options={years}
          value={year}
          onChange={(e, data) => onChange({year: data.value})}
        />
      </div>
    );
  }
}